import { render, staticRenderFns } from "./workflow-request.vue?vue&type=template&id=6f617352&scoped=true"
import script from "./workflow-request.vue?vue&type=script&lang=js"
export * from "./workflow-request.vue?vue&type=script&lang=js"
import style0 from "./workflow-request.vue?vue&type=style&index=0&id=6f617352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f617352",
  null
  
)

export default component.exports